export default "__VITE_ASSET__56ca8872__"